var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSugarcrmLogoWhiteCube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1116_132901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4008 0.300049L0.300781 6.90005V11.3L17.4008 18L34.4008 11.3V6.90005L17.4008 0.300049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.300781 23.4001V27.7001L17.4008 34.4001L34.4008 27.7001V23.4001L17.4008 30.0001L0.300781 23.4001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.300781 15.1001V19.5001L17.4008 26.2001L34.4008 19.5001V15.1001L17.4008 21.8001L0.300781 15.1001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1116_132901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 35,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSugarcrmLogoWhiteCube);
export default __webpack_public_path__ + "static/media/sugarcrm-logo-white-cube.3f1e3bd96daf645e7611e9d0b1afefe8.svg";
export { ForwardRef as ReactComponent };